import { useEffect, useState } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { doc, onSnapshot } from 'firebase/firestore';
import { auth, db } from '../firebase';
import { getUserRole, canAccessAdmin } from '../utils/roles';

// ══════════════════════════════════════════════════════════════════
//  MAINTENANCE GATE — suis dibaca pelanggan  (2026-09-28)
//  - Doc: config/maintenance_gate { enabled, title, body, updatedAt }.
//  - Admin ON/OFF di /admin/announce (MaintenanceGateAdmin.jsx).
//  - Pelanggan log masuk + suis ON → modal penuh skrin tanpa butang tutup
//    (MaintenanceGate.jsx). Admin/moderator TIDAK disekat.
//  - Kenapa masih jalan bila server (Cloud Functions) down: Firestore +
//    Hosting kekal hidup semasa billing ditutup (disahkan 28 Sept) —
//    hanya Functions yang mati.
//  - Gagal baca (rules belum deploy / rangkaian) → gate OFF. Sengaja
//    fail-open: ralat bacaan tidak boleh mengunci semua pelanggan.
//  ⚠️ Rules WAJIB all-auth-read pada config/maintenance_gate.
// ══════════════════════════════════════════════════════════════════

const MATI = { aktif: false, title: '', body: '' };

export default function useMaintenanceGate() {
  const [uid, setUid] = useState(null);
  const [staff, setStaff] = useState(false);
  const [gate, setGate] = useState(MATI);

  useEffect(() => onAuthStateChanged(auth, (u) => {
    setUid(u?.uid || null);
    setStaff(!!u && canAccessAdmin(getUserRole(u.email)));
  }), []);

  useEffect(() => {
    if (!uid || staff) return undefined;
    return onSnapshot(
      doc(db, 'config', 'maintenance_gate'),
      (snap) => {
        const d = snap.exists() ? snap.data() : {};
        setGate({
          aktif: d.enabled === true,
          title: typeof d.title === 'string' ? d.title.slice(0, 120) : '',
          body: typeof d.body === 'string' ? d.body.slice(0, 1500) : '',
        });
      },
      (e) => {
        console.warn('[MaintenanceGate] tak dapat baca suis — gate dianggap OFF', e?.code || e);
        setGate(MATI);
      }
    );
  }, [uid, staff]);

  // Log keluar / akaun staff → sentiasa OFF (nilai snapshot lama diabaikan).
  return !uid || staff ? MATI : gate;
}
